import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    standalone: false
})
export class SelectComponent extends FieldType<FieldTypeConfig> {
    valueFn = (item: any): string => item.value;

    displayFunction(item: any): string {
        if (item) {
            return item.label;
        } else {
            return '';
        }
    }
}
